// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from 'react';
import { TableCell, Typography, Divider } from '@mui/material';

interface DividedCellProps {
  top: string|undefined; 
  bottom: string|undefined;
}

const DividedCell: React.FC<DividedCellProps> = ({ top, bottom }) => {
  return (
    <TableCell>
      <Typography variant={'body1'} marginBottom={'5px'}>
        {top}
      </Typography>
      <Divider />
      <Typography variant={'subtitle2'} marginTop={'5px'}>
        {bottom}
      </Typography>
    </TableCell>
  );
};

export default DividedCell;
